export const userActiontype = {
  USER_PROFILE: 'USER_PROFILE', // WHEN USER DATA IS RECEIVED,
  USER_MALLSWITCH: 'USER_MALLSWITCH', // WHEN USER SWITCH A MALL
  USER_ONLOGOUT:  'USER_ONLOGOUT',
}